import * as React from 'react';
import PacklinkLoadDraft from './packlink_load_draft';
import { ChildProps, graphql, MutationFn } from 'react-apollo';
import gql from 'graphql-tag';
import { CorePacklinkCreateDraft } from '../schemas/rql';

interface ExternalProps {
  onDraftSuccess(): void;
  orderId: string;
  order?: any;
}

interface MutationProps {
  mutate: MutationFn<CorePacklinkCreateDraft.Mutation, CorePacklinkCreateDraft.Variables>;
}

export type Props = ChildProps<ExternalProps> & MutationProps;

export function PacklinkCreateDraft(props: Props) {
  const {
    onDraftSuccess,
    orderId,
    order,
  } = props;

  React.useEffect(() => {
    createDraft();
  });

  async function createDraft() {
    props.mutate({ variables: { input: { orderId } } });
  }

  return (
    <PacklinkLoadDraft
      onDraftSuccess={onDraftSuccess}
      order={order}
    />
  );
}

const withMutation = graphql<ExternalProps, CorePacklinkCreateDraft.Mutation, CorePacklinkCreateDraft.Variables>(gql`
mutation Core_Packlink_CreateDraft($input: Input_core_apimessages_CreatePacklinkDraftRequest) {
  createPacklinkDraft(input: $input) {
    shipment {
      id
    }
  }
}`,
);

export default withMutation(PacklinkCreateDraft);



// WEBPACK FOOTER //
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/src/components/packlink_create_draft.tsx